/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-09 15:38:39
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-12 15:55:18
 * @name: 路由
 * @Description: 路由
 * @FilePath: \project\src\router\index.js
 * @Author: desktop
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'index',
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('@/views/index/index.vue'),
    redirect: '/index/afterSale',
    meta: {
      title: '售前售后管理系统',
      keepalive: true,
    },
    children: [
      {
        path: 'delay',
        name: 'indexDelay',
        component: () => import('@/views/index/delay/delayRouter.vue'),
        meta: {
          title: '延期审批',
        },
      },
      {
        path: 'bargainPrice',
        name: 'indexBargainPrice',
        component: () => import('@/views/index/bargainPrice/bargainPriceRouter.vue'),
        meta: {
          title: '特价审批',
        },
      },
      {
        path: 'payConfirm',
        name: 'indexPayConfirm',
        component: () => import('@/views/index/payConfirm/payConfirmRouter.vue'),
        meta: {
          title: '支付确认',
        },
      },
      {
        path: 'myOrder',
        name: 'indexMyOrder',
        component: () => import('@/views/index/myOrder/myOrderRouter.vue'),
        meta: {
          title: '我的订单',
        },
      },
      {
        path: 'afterSale',
        name: 'indexAfterSale',
        component: () => import('@/views/index/afterSale/afterSaleRouter.vue'),
        meta: {
          title: '我的售后',
          keepalive: true,
        },
        redirect: 'afterSale/afterSaleList',
        children: [
          {
            path: 'afterSaleList',
            name: 'indexAfterSaleList',
            component: () => import('@/views/index/afterSale/afterSaleList/afterSaleList.vue'),
            meta: {
              title: '',
              keepalive: true,
            },
          },
          {
            path: 'waitApproveDeal',
            name: 'indexWaitApproveDeal',
            component: () => import('@/views/index/afterSale/waitApproveDeal/waitApproveDeal.vue'),
            meta: {
              title: '工单详情',
            },
          },
          {
            path: 'waitApproveSignDealScheme',
            name: 'indexWaitApproveSignDealScheme',
            component: () => import('@/views/index/afterSale/waitApproveSignDealScheme/waitApproveSignDealScheme.vue'),
            meta: {
              title: '填写处理方案',
            },
          },
          {
            path: 'updateDealScheme',
            name: 'indexUpdateDealScheme',
            component: () => import('@/views/index/afterSale/updateDealScheme/updateDealScheme.vue'),
            meta: {
              title: '修改处理方案',
            },
          },
          {
            path: 'waitApproveSignAmount',
            name: 'indexWaitApproveSignAmount',
            component: () => import('@/views/index/afterSale/waitApproveSignAmount/waitApproveSignAmount.vue'),
            meta: {
              title: '填写定价',
            },
          },
          {
            path: 'waitConfirmUserPay',
            name: 'indexWaitConfirmUserPay',
            component: () => import('@/views/index/afterSale/waitConfirmUserPay/waitConfirmUserPay.vue'),
            meta: {
              title: '确认缴费',
            },
          },
          {
            path: 'waitConfirmLogistics',
            name: 'indexWaitConfirmLogistics',
            component: () => import('@/views/index/afterSale/waitConfirmLogistics/waitConfirmLogistics.vue'),
            meta: {
              title: '确认收件',
            },
          },
          {
            path: 'waitDealReissueArrangement',
            name: 'indexWaitDealReissueArrangement',
            component: () => import('@/views/index/afterSale/waitDealReissueArrangement/waitDealReissueArrangement.vue'),
            meta: {
              title: '指派发件人',
            },
          },
          {
            path: 'waitDealReissue',
            name: 'indexWaitDealReissue',
            component: () => import('@/views/index/afterSale/waitDealReissue/waitDealReissue.vue'),
            meta: {
              title: '发件',
            },
          },
          {
            path: 'waitDealToDoorServiceArrangement',
            name: 'indexWaitDealToDoorServiceArrangement',
            component: () => import('@/views/index/afterSale/waitDealToDoorServiceArrangement/waitDealToDoorServiceArrangement.vue'),
            meta: {
              title: '指派上门人',
            },
          },
          {
            path: 'waitDealToDoorService',
            name: 'indexWaitDealToDoorService',
            component: () => import('@/views/index/afterSale/waitDealToDoorService/waitDealToDoorService.vue'),
            meta: {
              title: '上门',
            },
          },
          {
            path: 'waitDealSignServiceForm',
            name: 'indexWaitDealSignServiceForm',
            component: () => import('@/views/index/afterSale/waitDealSignServiceForm/waitDealSignServiceForm.vue'),
            meta: {
              title: '填写售后服务单',
            },
          },
        ]
      },
      {
        path: 'afterSaleWaitApprove',
        name: 'indexAfterSaleWaitApprove',
        component: () => import('@/views/index/afterSaleWaitApprove/afterSaleWaitApproveRouter.vue'),
        meta: {
          title: '待审批',
          keepalive: true,
        },
        redirect: 'afterSaleWaitApprove/afterSaleWaitApproveList',
        children: [
          {
            path: 'afterSaleWaitApproveList',
            name: 'indexAfterSaleWaitApproveList',
            component: () => import('@/views/index/afterSaleWaitApprove/afterSaleWaitApproveList/afterSaleWaitApproveList.vue'),
            meta: {
              title: '',
              keepalive: true,
            },
          },
        ]
      },
      {
        path: 'afterSaleWaitConfirm',
        name: 'indexAfterSaleWaitConfirm',
        component: () => import('@/views/index/afterSaleWaitConfirm/afterSaleWaitConfirmRouter.vue'),
        meta: {
          title: '待确认',
          keepalive: true,
        },
        redirect: 'afterSaleWaitConfirm/afterSaleWaitConfirmList',
        children: [
          {
            path: 'afterSaleWaitConfirmList',
            name: 'indexAfterSaleWaitConfirmList',
            component: () => import('@/views/index/afterSaleWaitConfirm/afterSaleWaitConfirmList/afterSaleWaitConfirmList.vue'),
            meta: {
              title: '',
              keepalive: true,
            },
          },
        ]
      },
      {
        path: 'afterSaleWaitDeal',
        name: 'indexAfterSaleWaitDeal',
        component: () => import('@/views/index/afterSaleWaitDeal/afterSaleWaitDealRouter.vue'),
        meta: {
          title: '待处理',
          keepalive: true,
        },
        redirect: 'afterSaleWaitDeal/afterSaleWaitDealList',
        children: [
          {
            path: 'afterSaleWaitDealList',
            name: 'indexAfterSaleWaitDealList',
            component: () => import('@/views/index/afterSaleWaitDeal/afterSaleWaitDealList/afterSaleWaitDealList.vue'),
            meta: {
              title: '',
              keepalive: true,
            },
          },
        ]
      },
    ]
  },//主页
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login.vue'),
    meta: {
      title: '登录',
    }
  }, //登录
  {
    path: '/updatePassword',
    name: 'updatePassword',
    component: () => import('@/views/updatePassword/updatePassword.vue'),
    meta: {
      title: '修改密码',
    }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/register/register.vue'),
    meta: {
      title: '注册',
    }
  }, //注册
  {
    path: '/registerSuccess',
    name: 'registerSuccess',
    component: () => import('@/views/register/registerSuccess.vue'),
    meta: {
      title: '注册成功',
    }
  }, //注册成功
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/404',
    component: () => import('@/views/errPage/404.vue'),
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const title = getPageTitle(to);
  // 设置页面缓存,跳转登录等页面时清空缓存
  if (['login'].includes(to.name)) {
    store.dispatch("cashView/clearCashRouters");
  } else {
    store.dispatch("cashView/addCashRouters", to);
  }
  document.title = setPageTitle(title); //设置标题
  next();
})

/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取路由标题
 * @param {Object} to 路由信息
 * @return {String} 路由标题
 */
const getPageTitle = (to) => {
  let title = to?.matched?.reverse()?.find(x => x.meta.title)?.meta?.title ?? ''; //倒序查询title
  to?.matched?.reverse(); //reverse会改变原数组,重置回去
  return title;
}
const setPageTitle = (pageTitle) => {
  const windowTitle = require("@/config/main.config.js").title;
  if (pageTitle) {
    return `${pageTitle} - ${windowTitle}`
  }
  return `${windowTitle}`
}
export default router
